import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../reimbursementsList/actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import store from '../../../store';

function* endReimbursements({ payload: { ids, type, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.reimbursements.end, data: { ids } });

    dispatch(listActions.getReimbursementsRequest({ type, curr_page: getState().getReimbursements.curr_page, filters: getState().getReimbursements.filters }));

    onSuccess && onSuccess();
    yield put(actions.endReimbursementsDone(data.results));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.endReimbursementsFailed,
      endpoint: api.reimbursements.end.url
    });
  }
}

export const endReimbursementsSaga = takeEvery(types.END_REIMBURSEMENTS_REQUEST, endReimbursements);